module.exports = __webpack_public_path__ + "img/logo.bd1e0b8c.png";